import { TaxFilingsPanel } from '@/components/tax-filings/TaxFilingsPanel';
import { useTaxYear } from '@/contexts/TaxYearContext';
import { TAX_FILINGS_TAB, TaxFilingsTab } from '@/types/taxFilings';
import { useEffect, useMemo } from 'react';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';

const VALID_TABS = new Set<string>(Object.values(TAX_FILINGS_TAB));

function parseTab(raw: string | undefined): TaxFilingsTab {
  if (raw && VALID_TABS.has(raw)) return raw as TaxFilingsTab;
  return TAX_FILINGS_TAB.TAX_SUMMARY;
}

export default function TaxFilingsPage() {
  const { selectedYear } = useTaxYear();
  const { tab: tabParam } = useParams<{ tab: string }>();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const tab = useMemo(() => parseTab(tabParam), [tabParam]);

  useEffect(() => {
    const legacyTab = searchParams.get('tab');
    if (legacyTab && VALID_TABS.has(legacyTab)) {
      navigate(`/tax-filings/${legacyTab}`, { replace: true });
      return;
    }
    if (tabParam && !VALID_TABS.has(tabParam)) {
      navigate('/tax-filings/tax-summary', { replace: true });
    }
  }, [tabParam, searchParams, navigate]);

  const handleTabChange = (nextTab: TaxFilingsTab) => {
    navigate(`/tax-filings/${nextTab}`, { replace: true });
  };

  return (
    <TaxFilingsPanel
      mode="user"
      taxYear={selectedYear}
      defaultTab={tab}
      showTitle
      onTabChange={handleTabChange}
    />
  );
}
